import { render, staticRenderFns } from "./_VFooter.vue?vue&type=template&id=73d1ebe3&scoped=true&"
var script = {}
import style0 from "./_VFooter.vue?vue&type=style&index=0&id=73d1ebe3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d1ebe3",
  null
  
)

export default component.exports